import get from 'lodash/get';
import { CartView } from '@rome/request/cart/v5/CartView';
import * as actions from 'actions/CartActions/CartSFLActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
const { GET_SAVE_FOR_LATER, MOVE_TO_CART_FROM_SFL, MOVE_TO_SFL_FROM_CART, REMOVE_FROM_SFL } = actions;
export default function saveForLaterData(state = {
    asyncStatus: AsyncStatus.INIT,
    data: {
        requestedStores: []
    }
}, action) {
    switch (action && action.type) {
        case GET_SAVE_FOR_LATER.REQUEST:
        case REMOVE_FROM_SFL.REQUEST:
        case MOVE_TO_CART_FROM_SFL.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case GET_SAVE_FOR_LATER.SUCCESS:
        case REMOVE_FROM_SFL.SUCCESS:
            const _1 = action;
            return {
                asyncStatus: AsyncStatus.SUCCESS,
                data: get(_1.data, ['sflDetails']),
                timeStamp: new Date().getTime()
            };
        case MOVE_TO_SFL_FROM_CART.SUCCESS:
            const _2 = action;
            return {
                asyncStatus: AsyncStatus.SUCCESS,
                data: get(_2.data, ['detailedCart', 'sflDetails']),
                timeStamp: new Date().getTime()
            };
        case MOVE_TO_CART_FROM_SFL.SUCCESS:
            const _3 = action;
            let newSFLData = spliceItemFromStoreData(state.data, _3.data.listingId, _3.data.response);
            return {
                asyncStatus: AsyncStatus.SUCCESS,
                data: newSFLData,
                timeStamp: new Date().getTime()
            };
        case GET_SAVE_FOR_LATER.ERROR:
        case REMOVE_FROM_SFL.ERROR:
        case MOVE_TO_CART_FROM_SFL.ERROR:
            const _4 = action;
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR,
                error: _4.error,
                pageLevelError: false
            });
        default:
            return state;
    }
}
/*
    Move to cart api will return back the cart response.
    So we have to explicitly remove the item from the sfl on the success.
*/
function spliceItemFromStoreData(currentStore, listingId, response) {
    if (!currentStore || !currentStore.requestedStores)
        return currentStore;
    /* Check to confirm the action is successful.
        In some failure sceanrios like cart count exceded, Mapi will return 200 with action status as false
    */
    let actions = get(response, ['detailedCart', 'cartDetails', 'actionDetails', 'actions'], []);
    const successfullActions = actions.filter(action => action.success && action.listingId === listingId);
    const successfullGroceryActions = actions.filter(action => action.success && action.listingId === null);
    if (successfullActions.length === 0 && successfullGroceryActions.length === 0)
        return currentStore;
    let updatedRequestedStores = currentStore.requestedStores.map(store => {
        if (store.basketType === CartView.FLIPKART || store.basketType === CartView.GROCERY) {
            /* Only buyable items are allowed to move to the cart */
            let updatedBuyableItems = store.buyableStateItems.filter(product => product.listingId !== listingId);
            return Object.assign(Object.assign({}, store), { buyableStateItems: updatedBuyableItems });
        }
        return store;
    });
    return Object.assign(Object.assign({}, currentStore), { sflItemCount: get(response, ['detailedCart', 'sflDetails', 'sflItemCount'], (currentStore.sflItemCount || 0) - 1), requestedStores: updatedRequestedStores });
}
